// extracted by mini-css-extract-plugin
export default {"highlight":"NYK59Lp8HWXixEAq2Epw"};